import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { AuthService } from './auth.service';
import { AccessType, UserAccess } from 'ops/common/models/access-settings';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({ providedIn: 'root' })
export class CustomGroupAccessSettingsService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private socketService: SocketMiddlewareService,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getAll(customGroupId): Promise<any> {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/custom-group/access-settings`, {
                params: { customGroupId },
            }),
        );
    }

    public create(usersAccess: any[], customGroupId: string): Promise<any> {
        const currentUserId = this.authService.getCurrentUserId();
        usersAccess.map((user: UserAccess) => {
            if (user.roleId === currentUserId) {
                user.accessLevel = AccessType.Owner;
            }
        });
        const body = {
            usersAccess,
            customGroupId,
        };
        return lastValueFrom(
            this.http.post(`${this.domain}/api/custom-group/access-settings`, body, {
                headers: this.headers,
            }),
        );
    }

    public update(updatedUsersAccess): Promise<any> {
        return lastValueFrom(
            this.http.put(`${this.domain}/api/custom-group/access-settings/`, updatedUsersAccess, {
                headers: this.headers,
            }),
        );
    }

    public updatePageAccess(publicAccess: boolean, customGroupId: string): Promise<any> {
        return lastValueFrom(
            this.http.put(
                `${this.domain}/api/custom-group/access-settings/` + customGroupId,
                { publicAccess },
                {
                    headers: this.headers,
                },
            ),
        );
    }
}
